import "./LoaderLight.css"
const LoaderLight = () => {
  return (
    <>
      <div className="loading">Loading&#8230;</div>
      <div className="content">{/* <h3>stuff goes in here!</h3> */}</div>
    </>
  )
}
export default LoaderLight
